<template>
  <div>
        <div class="about-banner">
            <img src="../../static/img/connect.png" />
            <div class="about-banner-word">
                <span>联系我们 contact us</span>
            </div>
        </div>
        <div class="news-change-title">
            <a href="javascript:;" class="news-change-item" :class="{'selected':item.isActive}" v-for="(item,index) in menu_active" @click="menuChange(index)" :key="index">{{item.title}}</a>
        </div>
        <div class="tab-card" style="display:block;">
            <div class="employ-detail">
                <div class="employ-content">
                    <h3>{{footsystem.name}}  </h3>
                    <div>地址：{{footsystem.ads}}<br />
                            电话：{{footsystem.tel}}<br />
                            邮编：100035</div>
                </div>
                <div class="employ-ditu">
                    <div id="allmap" style="height:260px;"></div>
                </div>
            </div>
        </div>
        <div class="tab-card" style="display:none;">
            <div class="message">
                <textarea placeholder="请输入内容 " style="resize:none;" v-model="Messcontent"></textarea>
                <button class="message-btn" @click="submit_message">提交内容</button>
            </div>
        </div>
  </div>
</template>

<script>
export default {
        name: 'Relationus',
        data () {
            return {
                menu_active: [
                    {
                        title: '公司位置',
                        link: '',
                        isActive: true,
                    },
                    {
                        title: '留言板',
                        link: '',
                        isActive: false,
                    },
                ],
                active: false,
                footsystem: '',
                messTo: {
                    token: '',
                    content: '',
                },
                Messcontent: '',
            }
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
            this.footData();
            this.map();
        },
        methods:{
            menuChange: function(tabIndex){
                var that = this;
                var tabCardCollection = document.querySelectorAll(".tab-card"),
                len = tabCardCollection.length;
                for(var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                    that.menu_active[i].isActive = false;
                }
                that.menu_active[tabIndex].isActive = true;
                tabCardCollection[tabIndex].style.display = "block";
            },
            footData: function(){
                var that = this;
                that.$http.post(that.baseUrl+that.config.system).then(function(ev){
                    if(ev.data.code == 100){
                        that.footsystem = ev.data.data;
                    }
                }).catch(function(error){
                    console.log(error);
                })
            },
            map: function(){
                // 百度地图API功能
                var sContent =
                "<h4 style='margin:0 0 5px 0;padding:0.2em 0'>北京德源兴业投资管理有限公司</h4>" +
                "<img style='float:right;margin:4px' id='imgDemo' src='./deyuan/static/img/logo.png' width='200' height='62' title=''/>" +
                "<p style='margin:0;line-height:1.5;font-size:13px;text-indent:2em'>地址: 北京市西城区平安里西大街10号</p>" +
                "</div>";
                var map = new BMap.Map("allmap");
                var point = new BMap.Point(116.375175  ,  39.938072);
                var marker = new BMap.Marker(point);
                var infoWindow = new BMap.InfoWindow(sContent);  // 创建信息窗口对象
                map.centerAndZoom(point, 15);
                map.addOverlay(marker);
                map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
                marker.addEventListener("click", function(){
                this.openInfoWindow(infoWindow);
                //图片加载完毕重绘infowindow
                document.getElementById('imgDemo').onload = function (){
                    infoWindow.redraw();   //防止在网速较慢，图片未加载时，生成的信息框高度比图片的总高度小，导致图片部分被隐藏
                }
                });
            },
            submit_message: function(){
                if(!localStorage.user){
                    this.$confirm('留言需要登录，是否跳转到登录页面', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '已跳转到登录页面'
                        });
                        this.$router.push({path: '/Login'});
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消跳转'
                        });
                    });
                }else{
                    //留言功能
                    var that = this;
                    that.messTo.token = localStorage.token;
                    that.messTo.content = that.Messcontent;
                    if(that.messTo.content){
                        that.$http.post(that.baseUrl+that.config.message,that.$qs.stringify(that.messTo)).then(function(ev){
                            if(ev.data.code == 100){
                                that.open2('留言成功');
                                that.Messcontent = '';
                            }
                            console.log(ev);
                        }).catch(function(error){
                            console.log(error);
                        })
                    }else{
                        that.open4('请输入留言内容');
                    }
                }
            },
            open2(succ_mes) {
                this.$message({
                    message: succ_mes,
                    type: 'success'
                });
            },
            //错误信息
            open4(mes) {
                this.$message.error(mes);
            }
        },
        created(){

        },
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/Relationus.vue